/**
 * Base classes for the component.
 * @type {String}
 */
export const BASE_CLASS = 'orca-rating';

/**
 * Minimum rating supported.
 * @type {Number}
 */
export const MIN_RATING = 0.1;

/**
 * Maximum rating supported (non inclusive).
 * @type {Number}
 */
export const MAX_RATING = 5.1;

/**
 * All available rating themes.
 * @type {Object<String>}
 */
export const THEMES = {
    FIVE_STARS: 'five_stars',
    ONE_STAR: 'one_star'
};

/**
 * All available theme colors.
 * @type {Record<'YELLOW'|'BLACK'|'PRO', string>}
 */
export const COLORS = {
    YELLOW: 'yellow',
    BLACK: 'black',
    PRO: 'pro'
};

/**
 * Mapping between a theme and its matching star count
 * @type {Object<Number>}
 */
export const STAR_COUNT_CONFIG = {
    [THEMES.FIVE_STARS]: 5,
    [THEMES.ONE_STAR]: 1
};
